import apiClient from "../apiClient";

const updateCommission = (data) => apiClient.post("/admin/edit-commission", data);
const getCommission = () => apiClient.get("/admin/get-commission");

export default {
  updateCommission,
  getCommission,
};
